import { Png } from "common/assets";
import { Config } from "common/config";
import { EColors } from "common/styles";
import { Styled } from "components/Styled";
import { StyledLinkPhone, StyledPhonesWrapper, StyledPicture, StyledTitlePhone } from "./styled";
import { Fade } from "react-awesome-reveal";

export const About = () => {
  const handleClick = () => {
    window.location.href = `#${Config.Section.contacts}`;
  };

  return (
    <Styled.Section color={EColors.white}>
      <Styled.ContainerWrapper>
        <Styled.Half>
          <Fade direction="left" triggerOnce>
            <Styled.H2>
              Надійний постачальник палива: оптовий продаж та імпорт
            </Styled.H2>
            <Styled.PBody1>
              Наша компанія спеціалізується на оптовому продажу та імпорті
              якісного палива з Литви для різних індустрійних потреб.
              <br />
              <br />
              Ми маємо досвід у галузі оптового продажу та імпорту палива, що
              дозволяє нам забезпечити ваш бізнес надійним паливом за
              конкурентною ціною.
              <br />
              <br />
              Наша команда професіоналів працює на протязі багатьох років,
              установлюючи тісні партнерські відносини з провідними виробниками
              та постачальниками палива. Ми пишаємось своєю здатністю
              забезпечити ваше підприємство необхідним обсягом палива вчасно та
              з відповідною якістю.
            </Styled.PBody1>
            <StyledTitlePhone>З питань оптового продажу або імпорту звертайтесь за телефонами:</StyledTitlePhone>
            <StyledPhonesWrapper >
              <StyledLinkPhone href="tel:+380675404737" target="_blank">+38 (067) 540 47 37</StyledLinkPhone>
              <StyledLinkPhone href="tel:+380994464420" target="_blank">+38 (099) 446 44 20</StyledLinkPhone>
           </StyledPhonesWrapper>
          </Fade>
        </Styled.Half>
        <Styled.Half>
          <Fade direction="right" triggerOnce>
            <StyledPicture src={Png.About} />
          </Fade>
        </Styled.Half>
      </Styled.ContainerWrapper>
    </Styled.Section>
  );
};
